(function () {
    'use strict';

    angular
        .module('recomActionPlanUpdateStatusControllers')
        .controller('ActionPlanUpdateStatusWelcomeController', Controller);

    Controller.$inject = ['$scope', '$modal', 'topBarService', 'businessUnit'];

    function Controller($scope, $modal, topBarService, businessUnit) {

        var title = businessUnit.TitleEN + ' Action Plans | Progress Tracking';
        topBarService.setTitleAndIcon(title, 'fa fa-road');

        $scope.openGovProcCreationModal = function () {

            // Modal to show
            var modalScope = $scope.$new(true);
            modalScope.businessUnit = businessUnit;
          
            var showModal = $modal({
                scope: modalScope,
                template: '/app/Main/recomActionPlanStatusUpdate/govProcEditModal.tpl.html',
                placement: 'center',
                backdrop: 'static'
            });

            modalScope.hideModal = function () {
                showModal.$promise.then(showModal.hide);
            };

            modalScope.okModal = function () {
                modalScope.hideModal();
            }
        };

        $scope.openGovProcCreationModal();
    }
})();